import {
  areAnswerInputStatesEqual,
  LearnLayoutContext,
} from "@-/dev.improve.haniverse.routes.nav.app.learn._context";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { DrillPageContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";
import { useEffect } from "react";

export function useDrillPageResetAnswerInputOnCharacterChange() {
  const [character] = useContextSelectors(DrillPageContext, (c) => c.character);
  const [setAnswerInputState] = useContextSelectors(
    LearnLayoutContext,
    (c) => c.setAnswerInputState,
  );

  useEffect(() => {
    const nextAnswerInputState = {
      answer: "",
      input: "",
      presetRating: null,
      validationState: null,
    } as const;
    setAnswerInputState((prev) =>
      areAnswerInputStatesEqual(prev, nextAnswerInputState) ? prev : nextAnswerInputState,
    );
    // The retained per-presentation keyboard owner resets its own text when activated.
    // A promotion finishing while Learn is hidden must not clear another screen's input.
  }, [character, setAnswerInputState]);
}
